import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";

const cardMotionStyles = `
  @keyframes authenticated-card-float {
    0%, 100% { transform: perspective(1200px) rotateX(1.8deg) rotateY(-4deg) translateY(0) scale(1); }
    50% { transform: perspective(1200px) rotateX(-2.8deg) rotateY(4deg) translateY(-7px) scale(1.008); }
  }
  @keyframes authenticated-card-sheen {
    0%, 58% { transform: translateX(-160%) skewX(-18deg); opacity: 0; }
    68% { opacity: .65; }
    84%, 100% { transform: translateX(360%) skewX(-18deg); opacity: 0; }
  }
  @media (prefers-reduced-motion: reduce) {
    .authenticated-card-motion, .authenticated-card-sheen { animation: none !important; }
  }
`;

export function TenantBlackLoyaltyCard({
  restaurantId,
  restaurant,
  loyaltyPoints,
  credit,
  onShowRules,
  onUseNow,
}) {
  return (
    <>
      <style>{cardMotionStyles}</style>
      <div className="authenticated-card-motion" style={{ transformStyle: "preserve-3d", animation: "authenticated-card-float 7s ease-in-out infinite" }}>
        <section className="relative isolate overflow-hidden rounded-[30px] border border-[#c9a227]/55 bg-[#08090b] p-5 text-white shadow-[0_26px_76px_rgba(0,0,0,0.42),0_0_34px_rgba(197,156,62,0.1)]" data-testid="customer-loyalty-hero">
      <div className="pointer-events-none absolute -inset-20 -z-10 opacity-80">
        <div className="absolute left-1/2 top-1/2 h-[130%] w-[75%] -translate-x-1/2 -translate-y-1/2 rotate-[-18deg] rounded-[50%] border border-[#e7c75f]/35 animate-[spin_18s_linear_infinite]" />
        <div className="absolute left-1/2 top-1/2 h-[115%] w-[65%] -translate-x-1/2 -translate-y-1/2 rotate-[28deg] rounded-[50%] border border-[#c62828]/30 animate-[spin_25s_linear_infinite_reverse]" />
        <span className="absolute left-[14%] top-[38%] h-2 w-2 rounded-full bg-[#f4d66d] shadow-[0_0_18px_5px_rgba(244,214,109,0.8)] animate-pulse" />
        <span className="absolute right-[16%] top-[20%] h-1.5 w-1.5 rounded-full bg-[#e34a4d] shadow-[0_0_16px_4px_rgba(227,74,77,0.75)] animate-pulse" />
      </div>
      <div className="pointer-events-none absolute -right-20 -top-24 h-56 w-56 rounded-full bg-[#c62828]/20 blur-3xl" />
      <div className="relative flex items-start justify-between gap-4">
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.24em] text-[#e7c75f]">Club {restaurant?.name || "del restaurante"}</p>
          <p className="mt-2 text-2xl font-black tracking-tight">Tu dinero vuelve contigo</p>
          <p className="mt-1 max-w-[260px] text-sm leading-5 text-white/60">Convierte tus puntos en crédito para tu próxima visita.</p>
        </div>
        {restaurant?.logo_url ? (
          <img src={restaurant.logo_url} alt={restaurant.name || "Restaurante"} className="h-14 w-14 rounded-2xl object-contain bg-white p-1.5 shadow-[0_0_24px_rgba(255,255,255,0.16)]" />
        ) : (
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-[#e7c75f]/50 bg-black/50 text-[10px] font-black tracking-widest text-[#e7c75f]">LOGO</div>
        )}
      </div>
      <div className="relative mt-6 rounded-2xl border border-white/10 bg-white/[0.06] p-4 backdrop-blur-sm">
        <div className="flex items-end justify-between gap-3">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/45">Disponible para usar</p>
            <p className="mt-1 text-4xl font-black tracking-tight text-[#f4d66d]" data-testid="loyalty-credit">{formatCredit(credit)}</p>
          </div>
          <Button onClick={onUseNow} className="h-11 rounded-xl bg-[#c62828] px-4 font-black text-white shadow-lg shadow-red-950/30 hover:bg-[#a91f1f]">USAR AHORA</Button>
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-white/10 pt-3 text-xs">
          <span className="text-white/50">{loyaltyPoints} puntos</span>
          <span className="font-semibold text-[#e7c75f]">100 puntos = 10 €</span>
        </div>
      </div>
      <div className="relative mt-4 flex items-center justify-between gap-3 text-[11px] text-white/45">
        <span>Saldo actualizado automáticamente</span>
        <Button variant="outline" onClick={onShowRules} className="h-9 rounded-xl border-[#f4d66d]/60 bg-[#f4d66d]/10 px-3 text-xs font-bold text-[#f4d66d] hover:bg-[#f4d66d]/20"><Info className="mr-1 h-3.5 w-3.5" />Ver reglas</Button>
      </div>
          <div className="authenticated-card-sheen pointer-events-none absolute inset-y-0 -left-1/3 z-20 w-1/3 bg-gradient-to-r from-transparent via-white/20 to-transparent" style={{ animation: "authenticated-card-sheen 8s ease-in-out infinite" }} />
        </section>
      </div>
    </>
  );
}

function formatCredit(amount) {
  const value = Number(amount || 0);
  return value.toLocaleString("es-ES", { style: "currency", currency: "EUR" });
}
